import { bool, string } from 'prop-types';
import React from 'react';
import BaseHtml from 'components/BaseHtml';
import { updateTagsInHtml, addNofollowToLink } from 'util/html';
import { addAffiliateTrackingToHtmlTag } from 'util/affiliates/amazon';
import {
  fixPinterestHouseToursLink,
  PINTEREST_HOUSE_TOURS_REGEXP
} from './helper';

/**
 * site-specific HTML concerns
 *
 * - add affiliate tags (query params) to affiliate links in affiliate-tagged
 *   posts
 * - add rel="nofollow" attr to all links in sponsored posts
 *
 */
function Html(props) {
  const { html: origHtml, isAffiliate, isSponsored } = props;

  const className = 'Html';

  const hasBadHouseToursLink = PINTEREST_HOUSE_TOURS_REGEXP.test(origHtml);

  const needsLinkUpdating = isAffiliate || isSponsored || hasBadHouseToursLink;

  const linkUpdaters = [];

  if (isAffiliate) {
    linkUpdaters.push(addAffiliateTrackingToHtmlTag);
  }

  if (isSponsored) {
    linkUpdaters.push(addNofollowToLink);
  }

  // CLEANUP: hopefully we won't need this workaround for very long...
  if (hasBadHouseToursLink) {
    linkUpdaters.push(fixPinterestHouseToursLink);
  }

  const html = needsLinkUpdating
    ? updateTagsInHtml(origHtml, 'a', linkUpdaters)
    : origHtml;

  return <BaseHtml {...props} className={className} html={html} />;
}

Html.defaultProps = {
  isAffiliate: false,
  isSponsored: false
};

Html.propTypes = {
  html: string.isRequired,
  isAffiliate: bool,
  isSponsored: bool
};

export default Html;
